import { PostAPI } from 'Components/Helper/Helpers';

export const BeneAdd = async (request) => {
    return PostAPI(request, 'NSDLPayoutBenificiary/AddBenificiary');
};

export const SelectBeneficiary = async (request) => {
    return PostAPI(request, 'NSDLPayoutBenificiary/SelectBeneficiary');
};

export const DeleteBene = async (request) => {
    return PostAPI(request, 'NSDLPayoutBenificiary/Delete');
};
export const UpdateStatus = async (request) => {
    return PostAPI(request, 'NSDLPayoutBenificiary/UpdateStatus');
};